export default __webpack_public_path__ + "static/media/whatsapp-logo.f99de59b.png";